export enum AvailableLocales {
    RuRu = 'ru-RU',
    EnUs = 'en-US'
}

export const availableLocales = [AvailableLocales.EnUs];
export const defaultLocale = AvailableLocales.EnUs;
